(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-comparison-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ej-comparison-gallery')) {
    customElements.define(
      'ej-comparison-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gallery-track]');
          if (!this.track || !this.querySelector('[data-gallery-step]')) return;
          this.track.querySelectorAll('[data-gallery-clone]').forEach((clone) => clone.remove());
          this.slides = Array.from(this.track.children);
          this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.current = 0;
          this.track.prepend(this.cloneSlide(this.slides[this.slides.length - 1]));
          this.track.append(this.cloneSlide(this.slides[0]));

          this.onScroll = () => {
            clearTimeout(this.settle);
            this.settle = setTimeout(() => {
              this.target = undefined;
              if (!this.touching) this.wrap();
            }, 120);
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.update();
            });
          };
          this.onTouch = (event) => {
            this.touching = event.type === 'touchstart';
            if (this.touching) this.target = undefined;
            else this.onScroll();
          };
          this.onClick = (event) => {
            const arrow = event.target.closest('[data-gallery-step]');
            if (arrow) this.step(Number(arrow.dataset.galleryStep));
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          ['touchstart', 'touchend', 'touchcancel'].forEach((type) => {
            this.track.addEventListener(type, this.onTouch, { passive: true });
          });
          this.addEventListener('click', this.onClick);
          this.resizeObserver = new ResizeObserver(() => this.jump(this.current));
          this.resizeObserver.observe(this.track);
          this.jump(0);
        }

        disconnectedCallback() {
          this.track?.removeEventListener('scroll', this.onScroll);
          ['touchstart', 'touchend', 'touchcancel'].forEach((type) => {
            this.track?.removeEventListener(type, this.onTouch);
          });
          this.removeEventListener('click', this.onClick);
          this.resizeObserver?.disconnect();
          clearTimeout(this.settle);
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        cloneSlide(slide) {
          const clone = slide.cloneNode(true);
          clone.setAttribute('data-gallery-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          return clone;
        }

        position() {
          const { scrollLeft, clientWidth } = this.track;
          return clientWidth ? Math.round(scrollLeft / clientWidth) : 1;
        }

        jump(index) {
          this.track.scrollLeft = (index + 1) * this.track.clientWidth;
        }

        wrap() {
          const position = this.position();
          if (position === 0) this.jump(this.slides.length - 1);
          else if (position > this.slides.length) this.jump(0);
        }

        step(direction) {
          const count = this.slides.length;
          const width = this.track.clientWidth;
          let target = (this.target ?? this.position()) + direction;
          if (target < 0 || target > count + 1) {
            const shift = target < 0 ? count : -count;
            this.track.scrollLeft += shift * width;
            target += shift;
          }
          if (this.reducedMotion.matches) {
            this.track.scrollLeft = target * width;
            this.wrap();
            return;
          }
          this.target = target;
          this.track.scrollTo({ left: target * width, behavior: 'smooth' });
        }

        update() {
          const count = this.slides.length;
          this.current = (this.position() - 1 + count) % count;
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ej-comparison')) {
    customElements.define(
      'ej-comparison',
      class extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('[data-comparison-rail]');
          if (!this.rail) return;
          this.arrows = Array.from(this.querySelectorAll('[data-comparison-step]'));
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          this.onChange = (entries) => {
            if (entries) this.resized = true;
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              if (this.resized) this.alignTitles();
              this.resized = false;
              this.update();
            });
          };
          this.onClick = (event) => {
            const arrow = event.target.closest('[data-comparison-step]');
            if (arrow) this.step(Number(arrow.dataset.comparisonStep));
          };

          this.rail.addEventListener('scroll', this.onChange, { passive: true });
          this.addEventListener('click', this.onClick);
          this.resizeObserver = new ResizeObserver(this.onChange);
          this.resizeObserver.observe(this.rail);
          this.alignTitles();
          this.update();
        }

        disconnectedCallback() {
          this.rail?.removeEventListener('scroll', this.onChange);
          this.removeEventListener('click', this.onClick);
          this.resizeObserver?.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
        }

        step(direction) {
          const item = this.rail.firstElementChild;
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          this.rail.scrollBy({
            left: direction * (item.getBoundingClientRect().width + gap),
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
          });
        }

        alignTitles() {
          const titles = Array.from(this.rail.querySelectorAll('.ej-comparison__title'));
          this.style.removeProperty('--ej-comparison-title-height');
          const tallest = Math.max(0, ...titles.map((title) => title.offsetHeight));
          if (tallest) this.style.setProperty('--ej-comparison-title-height', `${tallest}px`);
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.rail;
          const overflowing = scrollWidth - clientWidth > 1;
          this.toggleAttribute('data-overflowing', overflowing);
          const [prev, next] = this.arrows;
          prev.hidden = !overflowing;
          next.hidden = !overflowing;
          prev.disabled = scrollLeft <= 1;
          next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;

          const bounds = this.rail.getBoundingClientRect();
          Array.from(this.rail.children).forEach((item) => {
            const box = item.getBoundingClientRect();
            this.setReachable(item, !overflowing || (box.left >= bounds.left - 1 && box.right <= bounds.right + 1));
          });
        }

        setReachable(item, reachable) {
          item.querySelectorAll('a[href], button, input:not([type="hidden"])').forEach((element) => {
            const saved = element.hasAttribute('data-comparison-tabindex');
            if (reachable && saved) {
              const original = element.getAttribute('data-comparison-tabindex');
              element.removeAttribute('data-comparison-tabindex');
              if (original) element.setAttribute('tabindex', original);
              else element.removeAttribute('tabindex');
            } else if (!reachable && !saved) {
              element.setAttribute('data-comparison-tabindex', element.getAttribute('tabindex') || '');
              element.setAttribute('tabindex', '-1');
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
